import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ className, label, error, hint, id, ...rest }, ref) {
    const tid = id || `t-${Math.random().toString(36).slice(2, 8)}`;
    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={tid}
            className="block text-sm font-medium text-slate-700 mb-1.5"
          >
            {label}
          </label>
        )}
        <textarea
          id={tid}
          ref={ref}
          aria-invalid={!!error}
          className={cn(
            'block w-full rounded-md border bg-white text-sm text-slate-900',
            'px-3.5 py-2.5 resize-y min-h-[90px] transition-colors leading-relaxed',
            'placeholder:text-slate-400',
            'disabled:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-70',
            error
              ? 'border-red-300 focus:border-red-500'
              : 'border-slate-200 focus:border-brand-500',
            className
          )}
          {...rest}
        />
        {(error || hint) && (
          <p
            className={cn(
              'text-xs mt-1.5',
              error ? 'text-red-600' : 'text-slate-500'
            )}
          >
            {error || hint}
          </p>
        )}
      </div>
    );
  }
);
